import { getDateFromStringWithoutTime } from '@/lib/date'

const mapperActionPlanToForm = (form, mapperToOptions) => {
    const { title, description, tags, due_date, budget, status } = form
    const object = {
        title,
        description,
        tags: mapperToOptions(tags),
        status,
        dueDate: getDateFromStringWithoutTime(due_date, 'YYYY-MM-DD'),
        budget,
    }

    return object
}

export { mapperActionPlanToForm }
